/**
 * MarketingShell — wraps marketing pages with OperatorShell + secondary nav.
 */
import SecondaryNav from "@/components/dashboards/SecondaryNav";
import OperatorShell from "@/components/operator/OperatorShell";

interface Props {
  children: React.ReactNode;
}

export default function MarketingShell({ children }: Props) {
  return (
    <OperatorShell breadcrumbs={[{ label: "Marketing" }]} pageTitle="Marketing" pageMeta="Marketing workspace">
      <div className="sticky top-14 z-30">
        <SecondaryNav role="marketing" />
      </div>
      {children}
    </OperatorShell>
  );
}
